module.exports = __webpack_public_path__ + "img/yyt3.6d3b0627.png";